import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { resolvePath } from "@utils/resolvePath";

export const Wrapper = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
  border-radius: 12px;
  border: 1px solid #e8defd;
  background: var(--Surface-White, #fff);
  ${(props: { styles: any; }) => props?.styles}
  background-image: url(${resolvePath("/images/headerGradient.svg")})
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const NotFoundText = styled(Text)`
  color:  #040222;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px; 
`;

export const ReportHere = styled(Text)`
  color:  #1b73e8;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px; 
`;

export const IconContainer = styled.div`
  display: flex;
  width: 64px;
  height: 64px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;